// Entry point for the build script in your package.json
import * as Turbo from "@hotwired/turbo"
import "@hotwired/turbo-rails"
import "@rails/request.js"
import "./../components/index"
import "./controllers"

// Disable CSS transitions during Turbo page navigation
document.addEventListener('turbo:before-render', () => {
  document.documentElement.classList.add('turbo-loading')
})
document.addEventListener('turbo:render', () => {
  // Remove on next frame so the DOM settles without transitions
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('turbo-loading')
  })
})

// Custom Turbo Stream action to close an HTML <dialog> by id
Turbo.StreamActions.close_dialog = function () {
  document.getElementById(this.target)?.close()
}
// Custom Confirm modal — replaces browser confirm() for data-turbo-confirm
Turbo.setConfirmMethod((message, _element, _submitter) => {
  const dialog = document.getElementById("turbo-confirm")
  const messageEl = dialog.querySelector("[data-confirm-message]")
  messageEl.textContent = message
  dialog.showModal()

  return new Promise((resolve) => {
    dialog.addEventListener(
      "close",
      () => {
        resolve(dialog.returnValue === "confirm")
      },
      { once: true }
    )
  })
})

import "trix"
import "@rails/actiontext"
